function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import ShowTipContent from "@com/components/show-tips-content/index.vue";
import { Component, Vue, Prop } from "vue-property-decorator";
var EditShowTitle = /*#__PURE__*/ function(Vue1) {
    "use strict";
    _inherits(EditShowTitle, Vue1);
    var _super = _createSuper(EditShowTitle);
    function EditShowTitle() {
        _classCallCheck(this, EditShowTitle);
        var _this;
        _this = _super.apply(this, arguments);
        // 列间隙
        _this.columnGap = 10;
        // 是否显示 input 输入框
        _this.showInput = false;
        _this.inputName = "";
        return _this;
    }
    var _proto = EditShowTitle.prototype;
    _proto.handleChange = function handleChange(name) {
        if (this.disabled) return;
        if (name !== this.content) {
            this.$emit("change", name);
        } else {
            console.log("\u6CA1\u6709\u6539\u52A8\u4E0D\u9700\u8981\u63D0\u4EA4");
        }
    };
    _proto.handleShowInput = function handleShowInput() {
        var _this = this;
        if (this.disabled) return;
        this.showInput = true;
        this.$emit("focus");
        if (this.beforeAfterProcess) {
            this.inputName = this.beforeAfterProcess("before", this.content);
        } else {
            this.inputName = this.content;
        }
        this.$nextTick(function() {
            _this.$refs.nameInput.focus();
        });
    };
    _proto.handleInput = function handleInput(value) {
        if (this.trimContent) {
            this.inputName = value.trim();
        } else {
            this.inputName = value;
        }
    };
    _proto.handleBlur = function handleBlur() {
        if (this.disabled) return;
        this.showInput = false;
        this.$emit("blur");
        if (this.beforeAfterProcess) {
            this.inputName = this.beforeAfterProcess("after", this.inputName);
        }
        this.handleChange(this.inputName);
    };
    _createClass(EditShowTitle, [
        {
            key: "builtInStyle",
            get: function get() {
                return {
                    maxWidth: this.width + "px"
                };
            }
        },
        {
            key: "builtInRightColStyle",
            get: function get() {
                return {
                    width: this.actionColumnWidth + "px"
                };
            }
        },
        {
            key: "maxTitleShowWidth",
            get: function get() {
                if (this.editable) {
                    if (this.followable) {
                        return this.width;
                    }
                    return this.width - this.actionColumnWidth - this.columnGap;
                }
                return this.width;
            }
        },
        {
            key: "builtInLeftColStyle",
            get: function get() {
                return {
                    maxWidth: this.maxTitleShowWidth + "px"
                };
            }
        }
    ]);
    return EditShowTitle;
}(Vue);
__decorate([
    Prop({
        type: String,
        required: true
    }) // 文案
], EditShowTitle.prototype, "content", void 0);
__decorate([
    Prop({
        type: String
    }) // 文案
], EditShowTitle.prototype, "readonlyContent", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: true
    }) // 是否删除前后空格
], EditShowTitle.prototype, "trimContent", void 0);
__decorate([
    Prop({
        type: Number,
        required: false
    }) // 最长限制宽度
], EditShowTitle.prototype, "width", void 0);
__decorate([
    Prop({
        type: String,
        required: false
    }) // 需要高亮的文案
], EditShowTitle.prototype, "highlight", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: true
    }) // 是否允许编辑
], EditShowTitle.prototype, "editable", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    }) // 是否禁用
], EditShowTitle.prototype, "disabled", void 0);
__decorate([
    Prop({
        type: Function,
        required: false
    }) // 输入输出之前的执行事件，针对特殊逻辑的钩子函数
], EditShowTitle.prototype, "beforeAfterProcess", void 0);
__decorate([
    Prop({
        type: Object,
        required: false
    }) // input 的属性
], EditShowTitle.prototype, "inputProp", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    }) // 编辑光标是否跟随后面
], EditShowTitle.prototype, "followable", void 0);
__decorate([
    Prop({
        type: Boolean,
        required: false,
        default: false
    }) // 编辑光标是否跟随后面
], EditShowTitle.prototype, "activable", void 0);
__decorate([
    Prop({
        type: Number,
        required: false,
        default: 24
    }) // 图标大小
], EditShowTitle.prototype, "iconSize", void 0);
__decorate([
    Prop({
        type: Number,
        required: false,
        default: 24
    }) // 操作列的宽度
], EditShowTitle.prototype, "actionColumnWidth", void 0);
__decorate([
    Prop({
        type: String
    }) // tip的位置
], EditShowTitle.prototype, "tipPlacement", void 0);
EditShowTitle = __decorate([
    Component({
        components: {
            ShowTipContent: ShowTipContent
        }
    })
], EditShowTitle);
export { EditShowTitle as default };
